// bulkUploadSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BulkUpdate } from "../../types/bulkUpdate";
import { RequestCertConnectBulkUpload, validateCertConnectBulkUpload } from "../thunks/bulkUpdateThunk";

interface BulkUploadState {
  bulkUpdateList: BulkUpdate[];
  pageSize: number;
  currentPage: number;
  loading: boolean;
  requestLoading: boolean;
  error: string | null;
  success: boolean;
  isModalOpen: boolean;
}

const initialState: BulkUploadState = {
  bulkUpdateList: [],
  pageSize: 10,
  currentPage: 1,
  error: null,
  loading: false,
  requestLoading: false,
  success: null,
  isModalOpen: false
};

const bulkUploadSlice = createSlice({
  name: "bulkUpload",
  initialState,
  reducers: {
    setBulkData(state, action: PayloadAction<BulkUpdate[]>) {
      state.bulkUpdateList = action.payload;
    },
    clearBulkData(state) {
      state.bulkUpdateList = [];
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload;
      state.currentPage = 1; // reset page when size changes
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    filterEligible(state) {
      state.bulkUpdateList = state.bulkUpdateList.filter(
        (item) => item.Eligible === true
      );
    },
    showAll(state, action: PayloadAction<BulkUpdate[]>) {
      // restore all data (pass original list as payload)
      state.bulkUpdateList = action.payload;
    },
    openModal(state) {
      state.isModalOpen = true;
    },
    closeModal(state) {
      state.isModalOpen = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(validateCertConnectBulkUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(validateCertConnectBulkUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.bulkUpdateList = action.payload.Data;
        state.success = action.payload.Success;
      })
      .addCase(validateCertConnectBulkUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(RequestCertConnectBulkUpload.pending, (state) => {
        state.requestLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(RequestCertConnectBulkUpload.fulfilled, (state, action) => {
        state.requestLoading = false;
        state.bulkUpdateList = action.payload.Data;
        state.success = action.payload.Success;
      })

      .addCase(RequestCertConnectBulkUpload.rejected, (state, action) => {
        state.requestLoading = false;
        state.error = action.payload as string;
      })
  },
});



export const { setBulkData, clearBulkData, setPageSize, setCurrentPage, filterEligible, showAll, openModal, closeModal } = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;
